export default function MegaMenu () {
  const megaMenuClass = new MegaMenuClass()
  megaMenuClass.init()
}

class MegaMenuClass {
  constructor () {
    this.MEGA_MENU = document.getElementById('products-mega-menu')
    this.LAPTOP_TRIGGER = document.getElementById('megamenu-laptop-trigger')
    this.MOBILE_TRIGGER = document.getElementById('megamenu-mobile-trigger')
    this.OVERLAY = document.getElementById('megamenu-overlay')

    if (this.MEGA_MENU) {
      this.CLOSE_BUTTONS = this.MEGA_MENU.querySelectorAll('.mega-menu__close')
      this.BACK_BUTTONS = this.MEGA_MENU.querySelectorAll('.mega-menu__back')
    }
  }

  init () {
    if (!this.MEGA_MENU || !this.MOBILE_TRIGGER || !this.LAPTOP_TRIGGER) return

    this.WRAP = this.MEGA_MENU.querySelector('.mega-menu__wrap')

    this.PRODUCTS_COLUMN = this.MEGA_MENU.querySelector('.mega-menu__column--product-column')
    this.FEATURE_COLUMN = this.MEGA_MENU.querySelector('.mega-menu__column--feature-column')

    this.PRODUCTS = this.MEGA_MENU.querySelectorAll('.mega-menu__product')
    this.GROUPS = this.MEGA_MENU.querySelectorAll('.mega-menu__feature-group')

    if (this.PRODUCTS.length > 0 && this.GROUPS.length > 0) {
      for (let i = 0; i < this.PRODUCTS.length; i++) {
        const PRODUCT = this.PRODUCTS[i]
        const ARROW = PRODUCT.querySelector('.mega-menu__product-arrow')

        PRODUCT.addEventListener('mouseenter', () => {
          if (this.getScreenWidth() <= 1160) return
          this.activeId = PRODUCT.getAttribute('data-product-id')
          this.setActiveProduct()
          this.setActiveGroup()
          this.getScreenWidth() <= 700 && this.animateColumns()
        })

        ARROW && ARROW.addEventListener('click', () => {
          if (this.getScreenWidth() > 1160) return
          this.activeId = PRODUCT.getAttribute('data-product-id')
          this.setActiveProduct()
          this.setActiveGroup()
          this.getScreenWidth() <= 700 && this.animateColumns()
        })
      }
    }

    if (this.BACK_BUTTONS.length > 0) {
      for (let i = 0; i < this.BACK_BUTTONS.length; i++) {
        const BACK = this.BACK_BUTTONS[i]
        BACK.addEventListener('click', () => this.resetColumns())
      }
    }

    if (this.CLOSE_BUTTONS.length > 0) {
      for (let i = 0; i < this.CLOSE_BUTTONS.length; i++) {
        const CLOSE = this.CLOSE_BUTTONS[i]
        CLOSE.addEventListener('click', () => this.hideMegaMenu())
      }
    }

    this.LAPTOP_TRIGGER.addEventListener('mouseenter', () => {
      this.getScreenWidth() > 1161 && this.showMegaMenu()
    })

    this.LAPTOP_TRIGGER.addEventListener('mouseleave', () => {
      this.getScreenWidth() > 1161 && this.hideMegaMenu()
    })

    this.MEGA_MENU.addEventListener('mouseenter', () => {
      this.getScreenWidth() > 1161 && this.showMegaMenu()
    })

    this.MEGA_MENU.addEventListener('mouseleave', () => {
      this.getScreenWidth() > 1161 && this.hideMegaMenu()
    })

    this.MOBILE_TRIGGER.addEventListener('click', () => {
      this.closeMainNavigation()
      this.getScreenWidth() <= 1160 && this.toggleMegaMenu()
    })
  }

  showMegaMenu () {
    this.MEGA_MENU.classList.add('active')
    this.OVERLAY && this.OVERLAY.classList.add('show')
  }

  hideMegaMenu () {
    this.MEGA_MENU.classList.remove('active')
    this.OVERLAY && this.OVERLAY.classList.remove('show')
  }

  toggleMegaMenu () {
    this.MEGA_MENU.classList.toggle('active')
    this.OVERLAY && this.OVERLAY.classList.toggle('show')
  }

  setActiveProduct () {
    for (let i = 0; i < this.PRODUCTS.length; i++) {
      const PRODUCT = this.PRODUCTS[i]
      if (PRODUCT.getAttribute('data-product-id') === this.activeId) {
        PRODUCT.classList.add('active')
      } else {
        PRODUCT.classList.remove('active')
      }
    }
  }

  setActiveGroup () {
    for (let i = 0; i < this.GROUPS.length; i++) {
      const GROUP = this.GROUPS[i]
      if (GROUP.getAttribute('data-group-id') === this.activeId) {
        GROUP.classList.add('active')
      } else {
        GROUP.classList.remove('active')
      }
    }
  }

  getScreenWidth () {
    return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
  }

  closeMainNavigation () {
    const NAV_TOGGLE = document.getElementById('navigation-toggle')
    NAV_TOGGLE && NAV_TOGGLE.classList.remove('open')

    const NAV = document.getElementById('main_nav')
    NAV && NAV.classList.remove('open')

    const OVERLAY = document.getElementById('overlay')
    OVERLAY && OVERLAY.classList.remove('show')

    const SOLUTIONS_MENU = document.getElementById('solutions-menu')
    SOLUTIONS_MENU && SOLUTIONS_MENU.classList.remove('active')
  }

  animateColumns () {
    this.PRODUCTS_COLUMN.classList.add('translate')
    this.FEATURE_COLUMN.classList.add('translate')
    this.FEATURE_COLUMN.classList.add('translate-height')
    this.WRAP.classList.add('visible-overflow')
    setTimeout(() => {
      this.PRODUCTS_COLUMN.classList.add('translate-done')
      this.FEATURE_COLUMN.classList.add('translate-done')
      this.WRAP.classList.remove('visible-overflow')
    }, 300)
  }

  resetColumns () {
    this.PRODUCTS_COLUMN.classList.remove('translate')
    this.FEATURE_COLUMN.classList.remove('translate')
    this.PRODUCTS_COLUMN.classList.remove('translate-done')
    this.FEATURE_COLUMN.classList.remove('translate-done')
    this.WRAP.classList.add('visible-overflow')
    setTimeout(() => {
      this.FEATURE_COLUMN.classList.remove('translate-height')
      this.WRAP.classList.remove('visible-overflow')
    }, 300)
  }
}
